import React, { Component } from 'react';
//import FX from './functions/functions';
import Config from './Config';
import Panel from './Panel';
import Login from './Login';
import Wait from './Wait';
import InstanceBanner from './InstanceBanner';
import { hostInstance } from './functions/instance';
import './App.css';
import FX from './functions/functions';
import SweetAlert from 'sweetalert2-react';
//import { Scrollbars } from 'react-custom-scrollbars';


class App extends Component {
  constructor(props) {
    super(props);
    window.App = Config.root = this;
    var panel;
    console.log('Waiting');

    if(!localStorage.token){
      panel = 'login';
    }
    else {
      panel = 'dashboard';
    }

    this.state = {
      panel : panel,
      panelData: {packingStation:{},account:{}},
      menu_show: false,
      current_customer: {
        products: {count:0, list:[], page:1, limit:50, search:'', sort:'id:DESC', archive:-1, loading:false},
        orders: {count:0, list:[]},// [{id:9, reference:'Taint', tracking_code: '', name:'Tainted',dispatch_status:20},{id:10, reference:'Metry', name:'Tainted',dispatch_status:30}],
        dispatches: {count:0, list:[]},
        deliveries: {count:0, list:[]},
        returns: {count:0, list:[]}//[{id:9, reference:'Taint', expected_delivery_date:'2018-01-30',delivery_status:4},{id:10, reference:'Metry', expected_delivery_date:'2018-01-27',delivery_status:4},{id:11, reference:'Taintdwpoek', expected_delivery_date:'2018-01-23',delivery_status:4},{id:13, reference:'Pxsoxm', expected_delivery_date:'2018-01-25',delivery_status:4}],
      },
      loadNextPage:'dashboard',
      data_loaded: false,
      waiting: false,
      autoUpdate: true,
      // staging./dev. copies: which one, whether paths.json has been checked yet,
      // and (if it failed the check) why the page has stopped. See functions/instance.js
      instance: hostInstance(),
      pathsOk: !hostInstance(),
      blocked: ''
    };



    var n = window.location.pathname.split('/');
    var x = [];
    for (var i = 0; i < n.length; i++){
      if(n[i]){
        x.push(n[i]);
      }
    }
    if(0 <= Config.panels.indexOf(x[0])  && this.state.customer_id){
      this.state.panel = x[0];
      var found = false;
      if(x[1]){
        this.state.current_customer[x[0]].list.some(
        (ping) => {
          if(  parseInt(ping.id,10) ===  parseInt(x[1],10)){
            this.state.detail = ping;
            return found = true;
          }
          return false;
        }
        );
      }
    }
    else if (x.length){
      FX.navigate.bind(this,'dashboard', undefined ,'/',true)();
    }
    if(window.location.pathname.split('/')){
      console.log(window.location.pathname);
    }
    window.onpopstate = function(event, app) {
      console.log('popping');
      console.log(event);
      console.log(this);
      var s = event.state || {};
      // current_customer is intentionally omitted from pushed history state
      // (it can be multi-MB and overflow the pushState size cap), so restore it
      // from live memory — back/forward keeps the loaded lists and catalogue.
      if(this.state && this.state.current_customer){
        s = Object.assign({}, s, {current_customer: this.state.current_customer});
      }
      this.setState(s);
    }.bind(this);
    window.onscroll = function(event, app) {
      if (typeof this.onScroll === 'function' && (! (document.documentElement.scrollHeight - (document.body.clientHeight + window.scrollY)))){
        this.onScroll(event);
      }
      else {
        this.loadNextPageDefault(event);
      }
    }.bind(this);
    window.onkeydown = function(event, app) {
      if(typeof this.autoKey === 'function'){
        this.autoKey(event);
      }
      else
      console.log(event);
      console.log(this.autoKey);
    }.bind(this);
  }
  componentDidUpdate(prevProps, prevState){
    System.state = prevState;
    FX.doFocus(this);
    //console.log(Syst);
  }
  loadNextPage = () => {
    //console.log(this.state.current_customer[this.state.panel]);
  }
  loadNextPageDefault = () => {
    //console.log(this.state.current_customer[this.state.panel]);
  }
  componentDidMount(){
    setInterval(() => { this.minuteMaid(); }, 60000);
    window.addEventListener('resize', this.scale, true);
    this.scale();
    FX.loadDefaultData(this);
  }
  scale = () => {
    var banner = document.getElementById('InstanceBanner');
    document.getElementById('App').style.height = window.innerHeight - 5 - (banner ? banner.offsetHeight : 0) + 'px';
  }
  autoKey = (e) => {
    console.log(e);
  }
  textAction = (e) => {
    console.log(e)
  }

  // Products are no longer bulk-preloaded here. The catalogue is paged on
  // demand via the product_paged route (Product.js), and document editors
  // resolve the products they reference via product_lookup. Removing the old
  // limit=all refetch is what eliminates the large-customer OOM path.
  // minuteMaid still runs on its interval; add thunks here for any future
  // periodic refresh that does NOT pull the whole catalogue.
  updates = [];

  minuteMaid = () =>{
    console.log('mm');
    if(this.state.autoUpdate){
      this.updates.forEach((fx, i)=>{
        if ( typeof fx === 'function' ){
          fx.bind(this)();
          console.log('mm_' + i);
        }
      });
    }
  }

  render() {
    var show;
    var waiting = '';
    var login = '';
    if(this.state.blocked){
      show = (
        <div className="InstanceBlocked">
          <h2>This test site has stopped</h2>
          <p>{this.state.blocked}</p>
          <p>To protect live data the page has not contacted any backend, so nothing was read or changed. Ask whoever looks after this site to put the right <code>default/paths.json</code> on it.</p>
        </div>
      );
    }
    else if(!this.state.pathsOk) {
      waiting = 'waiting';
      show = (<div className="AppLoadScreen"/>);
    }
    else if(!localStorage.token){
      show = <Login root={this} />;
      login = ' login';
    }
    else if(!this.state.data_loaded) {
      waiting = 'waiting';
      show = (<div className="AppLoadScreen"/>);
    }
    else {
      show = <Panel root={this} panel={this.state.panel} />;
    }
    if(this.state.waiting){
      waiting = 'waiting';
    }
    return (
     <div className={'App ' + waiting + login } id="App">
      <InstanceBanner env={this.state.instance} root={this} />
      <Wait waiting={(waiting !=='')} />
      <div className="loadBar" />
      {show}
      <div className="footer_links" >
        <span className="copy">© Copyright Pelygo Limited 2018 - All rights reserved.</span>
        <span className="terms"><a target="_blank" href="https://vdepot.co.uk/wp-content/uploads/2024/05/FHDDS_Notice_of_UK_obligations__3___1_.pdf">Notice of FHDDS Obligations</a>&nbsp;|&nbsp;<a target="_blank" href="http://vdepot.co.uk/documents/terms-and-conditions.html">Terms &amp; Conditions</a>&nbsp;|&nbsp;<a target="_blank" href="http://vdepot.co.uk/documents/privacy.html">Privacy</a></span>
      </div>
     </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js